module.exports = "/Public/build/564397662b8b8f2943d0d9aa55b7bc8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorMenu/cross.svg
// module id = 836
// module chunks = 0